export default "__VITE_ASSET__aa8ecd8d__"